export const OrganizationChangeTypes = {
  ADD_ADDITIONAL_LOCATION: 'ADD_ADDITIONAL_LOCATION',
  ADD_NEW_EMPLOYEE: 'ADD_NEW_EMPLOYEE',
  LANDLINE_PHONE_NUMBER_CHANGE: 'LANDLINE_PHONE_NUMBER_CHANGE',
  MAIN_LOCATION_CHANGE: 'MAIN_LOCATION_CHANGE',
  PHONE_NUMBER_CHANGE: 'PHONE_NUMBER_CHANGE',
};
